/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Betkooperationspartner1Inputs */

const de__field_betkooperationspartner1 = /** @type {(inputs: _Field_Betkooperationspartner1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beteiligter Kooperationspartner`)
};

/**

* @param {_Field_Betkooperationspartner1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_betkooperationspartner1 = /** @type {((inputs?: _Field_Betkooperationspartner1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Betkooperationspartner1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_betkooperationspartner1(inputs)
});
export { _field_betkooperationspartner1 as "_field_betKooperationspartner" }